import React from 'react'
import * as R from 'ramda'

import { AtsLockContext } from 'components/common/AtsLock'
import { Pane } from 'components/shared/Pane/Pane'

import { getTab } from './model'

import styles from './JobDetails.module.scss'

export const JobDetailsTabs = ({
  activeTab,
  project,
  tabs,
  hasInterviewModule,
  hasInterviewTemplate,
  isInterviewAvailable,
  onTabChange,
}) => {
  const { owner_ats } = project ?? {}

  const tab = getTab({
    activeTab,
    project,
    hasInterviewModule,
    hasInterviewTemplate,
    isInterviewAvailable,
  })

  const isAtsLocked = owner_ats ? R.T() : R.F()

  const context = React.useMemo(
    () => ({
      owner: owner_ats,
      isAtsLocked,
    }),
    [owner_ats, isAtsLocked],
  )

  return (
    <Pane className={styles.details}>
      <Pane.TabsBar
        tabClassName={styles.tab}
        onClick={onTabChange}
        activeTab={activeTab}
        tabs={tabs}
      />
      <AtsLockContext.Provider value={context}>{tab}</AtsLockContext.Provider>
    </Pane>
  )
}

